<template>
  <div class="mobile-menu-header">
    <component
      :is="logoHref ? 'router-link' : 'span'"
      v-if="fields.mobileOpenLogo?.value?.src || fields.logoText?.value"
      :to="logoHref || undefined"
      class="mobile-menu-header__link no-underline"
      @click="$emit('closeMobileMenu')"
    >
      <img
        v-if="fields.mobileOpenLogo?.value?.src"
        class="mobile-menu-header__logo"
        data-test-id="mobile-menu-header__logo"
        :src="fields.mobileOpenLogo?.value?.src"
        :width="fields.mobileOpenLogo?.value?.width"
        :height="fields.mobileOpenLogo?.value?.height"
        :alt="fields.mobileOpenLogo?.value?.alt"
      />
      <span v-else class="mobile-menu-header__logo-text font-m">
        {{ fields.logoText?.value }}
      </span>
    </component>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { SitecoreField, ImageValue, LinkField } from '@/types';

interface MobileMenuHeaderFields {
  mobileOpenLogo?: SitecoreField<ImageValue>;
  logoLink?: LinkField;
  logoText?: SitecoreField<string>;
}

interface MobileMenuHeaderProps {
  fields?: MobileMenuHeaderFields;
}

const props = withDefaults(defineProps<MobileMenuHeaderProps>(), {
  fields: () => ({}) as MobileMenuHeaderFields,
});

const logoHref = computed(() => props.fields.logoLink?.value?.href);

defineEmits<{
  closeMobileMenu: [];
}>();
</script>

<style lang="scss">
@import './scss/MobileMenuHeader.scss';
</style>
